/**
 * Showcase mega menu
 * - Left category tabs
 * - Hero 3-slide carousel (autoplay + dots + arrows)
 * - Bottom category card track
 */
(function () {
  function activateTab(root, index) {
    const tabs = root.querySelectorAll('[data-showcase-tab]');
    const panels = root.querySelectorAll('[data-showcase-panel]');
    const nextIndex = Number(index);

    tabs.forEach((tab) => {
      const isActive = Number(tab.dataset.showcaseIndex) === nextIndex;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      tab.tabIndex = isActive ? 0 : -1;
    });

    panels.forEach((panel) => {
      const isActive = Number(panel.dataset.showcaseIndex) === nextIndex;
      panel.classList.toggle('is-active', isActive);
      if (isActive) {
        panel.removeAttribute('hidden');
        syncHeroSquare(panel);
        restartSlider(panel.querySelector('[data-showcase-slider]'));
      } else {
        panel.setAttribute('hidden', '');
        pauseSlider(panel.querySelector('[data-showcase-slider]'));
      }
    });
  }

  function goToSlide(slider, index) {
    if (!slider) return;
    const slides = Array.from(slider.querySelectorAll('[data-showcase-slide]'));
    const dots = Array.from(slider.querySelectorAll('[data-showcase-dot]'));
    if (!slides.length) return;

    const next = ((index % slides.length) + slides.length) % slides.length;
    slider.dataset.activeSlide = String(next);

    slides.forEach((slide, i) => {
      const active = i === next;
      slide.classList.toggle('is-active', active);
      if (active) slide.removeAttribute('hidden');
      else slide.setAttribute('hidden', '');
    });

    dots.forEach((dot, i) => {
      const active = i === next;
      dot.classList.toggle('is-active', active);
      dot.setAttribute('aria-selected', active ? 'true' : 'false');
    });
  }

  function nextSlide(slider, delta) {
    const current = Number(slider.dataset.activeSlide || 0);
    goToSlide(slider, current + delta);
  }

  function pauseSlider(slider) {
    if (!slider || !slider._timer) return;
    clearInterval(slider._timer);
    slider._timer = null;
  }

  function restartSlider(slider) {
    if (!slider) return;
    pauseSlider(slider);
    if (slider.dataset.autoplay !== 'true') return;
    const slides = slider.querySelectorAll('[data-showcase-slide]');
    if (slides.length < 2) return;

    const interval = Number(slider.dataset.interval || 4500);
    slider._timer = setInterval(() => {
      if (slider.closest('[hidden]')) return;
      nextSlide(slider, 1);
    }, interval);
  }

  function syncHeroSquare() {}

  function syncVisibleHeroes(root) {
    root.querySelectorAll('[data-showcase-panel]').forEach((panel) => {
      if (!panel.hasAttribute('hidden')) syncHeroSquare(panel);
    });
  }

  function bindHeroSlider(panel) {
    const slider = panel.querySelector('[data-showcase-slider]');
    if (!slider || slider.dataset.sliderBound === 'true') return;
    slider.dataset.sliderBound = 'true';
    slider.dataset.activeSlide = '0';

    const prev = slider.querySelector('[data-showcase-slide-prev]');
    const next = slider.querySelector('[data-showcase-slide-next]');
    const dots = slider.querySelectorAll('[data-showcase-dot]');

    if (prev) {
      prev.addEventListener('click', (evt) => {
        evt.preventDefault();
        evt.stopPropagation();
        nextSlide(slider, -1);
        restartSlider(slider);
      });
    }

    if (next) {
      next.addEventListener('click', (evt) => {
        evt.preventDefault();
        evt.stopPropagation();
        nextSlide(slider, 1);
        restartSlider(slider);
      });
    }

    dots.forEach((dot) => {
      dot.addEventListener('click', (evt) => {
        evt.preventDefault();
        evt.stopPropagation();
        goToSlide(slider, Number(dot.dataset.slideIndex || 0));
        restartSlider(slider);
      });
    });

    slider.addEventListener('mouseenter', () => pauseSlider(slider));
    slider.addEventListener('mouseleave', () => {
      if (!panel.hasAttribute('hidden')) restartSlider(slider);
    });

    if (panel.classList.contains('is-active') && !panel.hasAttribute('hidden')) {
      restartSlider(slider);
    }
  }

  function bindCategoryTrack(panel) {
    const track = panel.querySelector('[data-showcase-track]');
    if (!track || track.dataset.carouselBound === 'true') return;
    track.dataset.carouselBound = 'true';

    const prev = panel.querySelector('[data-showcase-prev]');
    const next = panel.querySelector('[data-showcase-next]');
    const step = () => {
      const card = track.querySelector('.mega-showcase__cat-card');
      const gap = 12;
      return card ? card.getBoundingClientRect().width + gap : Math.floor(track.clientWidth * 0.7);
    };

    if (prev) {
      prev.addEventListener('click', (evt) => {
        evt.preventDefault();
        evt.stopPropagation();
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });
    }

    if (next) {
      next.addEventListener('click', (evt) => {
        evt.preventDefault();
        evt.stopPropagation();
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });
    }
  }

  function initShowcase(root) {
    if (!root || root.dataset.showcaseReady === 'true') return;
    root.dataset.showcaseReady = 'true';

    root.addEventListener('mouseover', (evt) => {
      const tab = evt.target.closest('[data-showcase-tab]');
      if (!tab || !root.contains(tab) || tab.classList.contains('is-active')) return;
      activateTab(root, tab.dataset.showcaseIndex);
    });

    root.addEventListener('keydown', (evt) => {
      const tab = evt.target.closest('[data-showcase-tab]');
      if (!tab || !root.contains(tab)) return;

      const tabs = Array.from(root.querySelectorAll('[data-showcase-tab]'));
      const current = tabs.indexOf(tab);
      if (current < 0) return;

      let next = current;
      if (evt.key === 'ArrowDown' || evt.key === 'ArrowRight') next = (current + 1) % tabs.length;
      else if (evt.key === 'ArrowUp' || evt.key === 'ArrowLeft') next = (current - 1 + tabs.length) % tabs.length;
      else if (evt.key === 'Home') next = 0;
      else if (evt.key === 'End') next = tabs.length - 1;
      else return;

      evt.preventDefault();
      activateTab(root, tabs[next].dataset.showcaseIndex);
      tabs[next].focus();
    });

    root.querySelectorAll('[data-showcase-panel]').forEach((panel) => {
      bindHeroSlider(panel);
      bindCategoryTrack(panel);
    });

    const active = root.querySelector('[data-showcase-tab].is-active');
    if (active) activateTab(root, active.dataset.showcaseIndex);
    syncVisibleHeroes(root);

    if (typeof ResizeObserver !== 'undefined') {
      const observer = new ResizeObserver(() => syncVisibleHeroes(root));
      observer.observe(root);
    } else {
      window.addEventListener('resize', () => syncVisibleHeroes(root));
    }
  }

  function initAll() {
    document.querySelectorAll('[data-mega-showcase]').forEach(initShowcase);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
